export const SalaryTypeToValue: Map<string, number> = new Map([
  ["HOURLY", 1],
  ["DAILY", 2],
  ["WEEKLY", 3],
  ["MONTHLY", 4],
  ["YEARLY", 5],
]);
